const COMMON_EMAIL_PROVIDERS = [
    // Germany / DACH first
    "gmx.de",
    "web.de",
    "gmail.com",
    "t-online.de",
    "outlook.de",
    "hotmail.de",
    "icloud.com",
    "freenet.de",
    "mail.de",
    "mailbox.org",
    "posteo.de",
    "yahoo.de",
    "arcor.de",
    "vodafone.de",
    "unitybox.de",
    "kabelmail.de",
    "ewetel.net",
    "osnanet.de",
    "online.de",
    "gmx.net",
    "gmx.com",
    "gmx.at",
    "gmx.ch",
    "aon.at",
    "a1.net",
    "bluewin.ch",
    "sunrise.ch",
    "hispeed.ch",

    // Global providers and common aliases
    "googlemail.com",
    "outlook.com",
    "outlook.at",
    "outlook.ch",
    "hotmail.com",
    "hotmail.at",
    "hotmail.ch",
    "live.com",
    "live.de",
    "live.at",
    "live.ch",
    "msn.com",
    "me.com",
    "mac.com",
    "icloud.de",
    "yahoo.com",
    "yahoo.co.uk",
    "yahoo.fr",
    "yahoo.it",
    "ymail.com",
    "rocketmail.com",
    "aol.com",
    "aol.de",
    "aim.com",
    "proton.me",
    "protonmail.com",
    "pm.me",
    "tutanota.com",
    "tutamail.com",
    "zoho.com",
    "zoho.eu",
    "mail.com",
    "email.com",
    "fastmail.com",
    "hey.com",
    "gmx.us",

    // Common EU ISP and regional domains
    "orange.fr",
    "wanadoo.fr",
    "free.fr",
    "sfr.fr",
    "bbox.fr",
    "laposte.net",
    "libero.it",
    "alice.it",
    "virgilio.it",
    "tin.it",
    "btinternet.com",
    "sky.com",
    "virginmedia.com",
    "ntlworld.com",
    "talktalk.net",

    // North America
    "comcast.net",
    "att.net",
    "verizon.net",
    "bellsouth.net",
    "charter.net",
    "cox.net",
    "sbcglobal.net",
    "shaw.ca",
    "rogers.com",

    // Larger international providers
    "yandex.com",
    "yandex.ru",
    "mail.ru",
    "rambler.ru",
    "bk.ru",
    "list.ru",
    "inbox.ru",
    "qq.com",
    "163.com",
    "126.com",
    "sina.com",
    "daum.net",
    "naver.com",
];

const MAX_SUGGESTIONS = 12;

function hasSingleAtSymbol(value: string): boolean {
    const firstAt = value.indexOf("@");
    return firstAt > -1 && firstAt === value.lastIndexOf("@");
}

export function getEmailAutocompleteSuggestions(rawValue: string): string[] {
    const value = rawValue.trim();
    if (!value) return [];

    if (!value.includes("@")) {
        return COMMON_EMAIL_PROVIDERS
            .slice(0, MAX_SUGGESTIONS)
            .map((provider) => `${value}@${provider}`);
    }

    if (!hasSingleAtSymbol(value)) return [];

    const [localPart, domainPart = ""] = value.split("@");
    if (!localPart) return [];

    return COMMON_EMAIL_PROVIDERS
        .filter((provider) => provider.startsWith(domainPart.toLowerCase()))
        .slice(0, MAX_SUGGESTIONS)
        .map((provider) => `${localPart}@${provider}`)
        .filter((suggestion) => suggestion.toLowerCase() !== value.toLowerCase());
}
